import jwtDecode from 'jwt-decode'

export default {
  loading(state) {
    return state.activeRequests > 0
  },

  loggedIn(state, getters) {
    return !!getters.sessionToken
  },

  sessionToken(state) {
    return state.session.token
  },

  currentUserId(state) {
    if (state.session.token) {
      const decoded = jwtDecode(state.session.token)
      return decoded.sub
    }

    return null
  },

  currentCompanyId(state) {
    if (state.session.token) {
      const decoded = jwtDecode(state.session.token)
      return decoded.company_id
    }

    return null
  }
}
